import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import {compress} from "./util/pako";

let stompClient = null;
const RECONNECT_DELAY = 5000; // 重连间隔时间
const MAX_RETRIES = 10; // 最大重连次数
let START_ENV_INTERVAL = null; // 启动环境的interval变量
let START_ENV_TIMEOUT = null; // 启动环境的timeout变量
let runParams = {}; // 运行时的变量
let envPodNameMap = {}; // 自定义环境与podName映射
let selectedEnvHere = {}; // 当前选中环境

// 代码执行的 running 消息
let runningMessage = [];
// running 消息消费顺序
let runningLogIndex = 1;

// 处理websocket running 消息
function handleRunningMessage(handler, messageBody) {
  try {
    const message = JSON.parse(messageBody);
    // console.log('messageBody', messageBody);
    // console.log('runningLogIndex', runningLogIndex, "logIndex",message.logIndex);
    // 将消息加入队列
    runningMessage.push(message);
    // 按 logIndex 排序
    runningMessage.sort((a, b) => a.logIndex - b.logIndex);
    recursiveRunningMessage(runningMessage, handler);
  } catch (e) {
    console.error("Failed to parse or process message:", e);
  }
}

function recursiveRunningMessage(runningMessage, handler) {
  for (let i = 0; i < runningMessage.length; i++) {
    const msg = runningMessage[i];
    if (msg.logIndex === runningLogIndex) {
      handler(msg);
      runningLogIndex++;
      recursiveRunningMessage(runningMessage, handler);
      return;
    }
  }
}

// 定义 sleep 函数
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const connect = (handler, token, retries = MAX_RETRIES) => {
  let wsUrl = process.env.REACT_APP_API_URL + '/ws';
  if (token) {
    wsUrl += '?token=' + token;
  }
  const socket = new SockJS(wsUrl, false);
  stompClient = Stomp.over(socket);
  if (process.env.REACT_APP_DEBUG_WS !== 'true') {
    stompClient.debug = () => {};
  }
  stompClient.connect({}, () => {
    console.log("Connected to WebSocket");
    stompClient.subscribe('/user/topic/runResult', (response) => {
      // console.log(JSON.parse(response.body), 'runResult runResult runResult');
      // 睡眠50ms
      sleep(50).then(() => {
        handler(JSON.parse(response.body), true);
      });
    });
    stompClient.subscribe('/user/topic/running', (response) => {
      handleRunningMessage(handler,response.body);
    });
    stompClient.subscribe('/user/topic/svg', (response) => {
      handleRunningMessage(handler,response.body);
      // handler(JSON.parse(response.body));
    });
    stompClient.subscribe('/user/topic/startResult', (response) => {
      // handler(JSON.parse(response.body), true);
      handler(JSON.parse(response.body), false, 'startResult');
      // console.log(JSON.parse(response.body), 'startResult startResult startResult');
      const { podName, status } = JSON.parse(response.body);
      if (status === 'SUCCESS') {
        envPodNameMap[selectedEnvHere.name] = podName;
        clearInterval(START_ENV_INTERVAL);
        clearTimeout(START_ENV_TIMEOUT);
        stompClient.send(
          '/app/run',
          {},
          JSON.stringify({ ...runParams, podName })
        );
      }
    });

    // 连接关闭后，尝试重连
    socket.onclose = (closeEvent) => {
      console.log("WebSocket connection closed:", closeEvent);
      //服务端业务原因拒绝, 直接显示错误信息, 不再重连
      if (closeEvent.code === 4500){
        handler({log:closeEvent.reason});
        return;
      }
      console.log("attempting to reconnect...");
      if (retries > 0) {
        setTimeout(() => connect(handler, retries - 1), RECONNECT_DELAY);
      } else {
        console.error("Max retries reached, unable to reconnect.");
      }
    };

  }, (error) => {
    console.error("WebSocket connection error:", error);
    // 连接失败后，尝试重连
    if (retries > 0) {
      setTimeout(() => connect(handler, token, retries - 1), RECONNECT_DELAY);
    } else {
      console.error("Max retries reached, unable to connect.");
    }
  });
}

const wsListen = (handler, token) => {
  connect(handler, token);
}

const wsRunCode = (lang, code, platform, envStatus, selectedEnv, todo) => {
  // envStatus: 0: 未启动, 1: 启动中, 2: 已启动
  // selectedEnv: 当前选中的环境
  selectedEnvHere = selectedEnv;
  clearInterval(START_ENV_INTERVAL);
  clearTimeout(START_ENV_TIMEOUT);
  let compressedCode = compress(code);
  //console.log('compressed', code.length, compressedCode.length);
  waitForConnected(stompClient, 5000).then(() => {
    const nameSpace = window.nameSpace || process.env.REACT_APP_RUN_WS_NAMESPACE;
    const podName = envPodNameMap[selectedEnv?.name] || window.podName || '';
    const container = window.container;
    // console.log(envPodNameMap, podName, 'envPodNameMap');
    const workspace = window.workspace;
    //console.log('send', lang, code.length, compressedCode.length, nameSpace, podName, workspace);
    const params = {
      lang,
      code: compressedCode,
      encodeScheme: 'PAKO',
      nameSpace,
      podName,
      container,
      workspace,
      platform,
      type: selectedEnv?.type ?? 0
    }
    runParams = params;
    runningMessage = [];
    runningLogIndex = 1;
    if (envStatus === 2 || !selectedEnv || selectedEnv.default) {
      stompClient.send(
        '/app/run',
        {},
        JSON.stringify({ ...params })
      );
    } else if (envStatus === 0 && ! selectedEnv.default) {
      console.log('/app/startEnv');
      START_ENV_TIMEOUT = setTimeout(() => {
        clearInterval(START_ENV_INTERVAL);
        clearTimeout(START_ENV_TIMEOUT);
      }, 11000);
      START_ENV_INTERVAL = setInterval(() => {
        stompClient.send(
          '/app/startEnv',
          {},
          selectedEnv?.image
        );
      }, 2000);
    }
  });
}
const wsInput = (command) => {
  waitForConnected(stompClient, 5000).then(() => {
    stompClient.send('/app/input', {}, JSON.stringify({ code: command}));
  });
}
const wsCommand = (command) => {
  waitForConnected(stompClient, 5000).then(() => {
    stompClient.send('/app/command', {}, JSON.stringify({command}));
  });
}

async function waitForConnected(client, timeout) {
  const period = 100;
  while (!client.connected && timeout > 0) {
    await delay(period);
    timeout -= period;
  }
  if (!client.connected) {
    throw new Error("ws connecting timeout");
  }
}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export { wsListen, wsRunCode, wsInput };
